import controller_0 from '@fify/form-bundle/controllers/number_input_controller.js';
import controller_1 from '@fify/form-bundle/controllers/tomselect_controller.js';
import controller_2 from '@fify/media-bundle/controllers/lightbox_controller.js';
import controller_3 from '@fify/media-bundle/controllers/swiper_controller.js';
import controller_4 from '@fify/websites-bundle/controllers/cookie-consent_controller.js';
import controller_5 from '@fify/websites-bundle/controllers/modal_controller.js';
import controller_6 from '@symfony/ux-autocomplete/dist/controller.js';
import controller_7 from '@symfony/ux-dropzone/dist/controller.js';
import controller_8 from '@symfony/ux-lazy-image/dist/controller.js';
import controller_9 from '@symfony/ux-live-component/dist/live_controller.js';
import '@symfony/ux-live-component/dist/live.min.css';
import controller_10 from '@symfony/ux-turbo/dist/turbo_controller.js';
import { Controller } from '@hotwired/stimulus';
export default {
  'fify--editorjs-bundle--editorjs': class extends Controller {
      constructor(context) {
          super(context);
          this.__stimulusLazyController = true;
      }
      initialize() {
          if (this.application.controllers.find((controller) => {
              return controller.identifier === this.identifier && controller.__stimulusLazyController;
          })) {
              return;
          }
          import('@fify/editorjs-bundle/controllers/editorjs_controller.js').then((controller) => {
              this.application.register(this.identifier, controller.default);
          });
      }
  },
  'fify--form-bundle--number-input': controller_0,
  'fify--form-bundle--submit-confirm': class extends Controller {
      constructor(context) {
          super(context);
          this.__stimulusLazyController = true;
      }
      initialize() {
          if (this.application.controllers.find((controller) => {
              return controller.identifier === this.identifier && controller.__stimulusLazyController;
          })) {
              return;
          }
          import('@fify/form-bundle/controllers/submit-confirm_controller.js').then((controller) => {
              this.application.register(this.identifier, controller.default);
          });
      }
  },
  'fify--form-bundle--collection': class extends Controller {
      constructor(context) {
          super(context);
          this.__stimulusLazyController = true;
      }
      initialize() {
          if (this.application.controllers.find((controller) => {
              return controller.identifier === this.identifier && controller.__stimulusLazyController;
          })) {
              return;
          }
          import('@fify/form-bundle/controllers/collection_controller.js').then((controller) => {
              this.application.register(this.identifier, controller.default);
          });
      }
  },
  'fify--form-bundle--json-editor': class extends Controller {
      constructor(context) {
          super(context);
          this.__stimulusLazyController = true;
      }
      initialize() {
          if (this.application.controllers.find((controller) => {
              return controller.identifier === this.identifier && controller.__stimulusLazyController;
          })) {
              return;
          }
          import('@fify/form-bundle/controllers/json_editor_controller.js').then((controller) => {
              this.application.register(this.identifier, controller.default);
          });
      }
  },
  'fify--form-bundle--tomselect': controller_1,
  'fify--media-bundle--ajax-dropzone': class extends Controller {
      constructor(context) {
          super(context);
          this.__stimulusLazyController = true;
      }
      initialize() {
          if (this.application.controllers.find((controller) => {
              return controller.identifier === this.identifier && controller.__stimulusLazyController;
          })) {
              return;
          }
          import('@fify/media-bundle/controllers/ajax-dropzone_controller.js').then((controller) => {
              this.application.register(this.identifier, controller.default);
          });
      }
  },
  'fify--media-bundle--collection-with-gallery': class extends Controller {
      constructor(context) {
          super(context);
          this.__stimulusLazyController = true;
      }
      initialize() {
          if (this.application.controllers.find((controller) => {
              return controller.identifier === this.identifier && controller.__stimulusLazyController;
          })) {
              return;
          }
          import('@fify/media-bundle/controllers/collection-with-gallery_controller.js').then((controller) => {
              this.application.register(this.identifier, controller.default);
          });
      }
  },
  'fify--media-bundle--file-with-gallery': class extends Controller {
      constructor(context) {
          super(context);
          this.__stimulusLazyController = true;
      }
      initialize() {
          if (this.application.controllers.find((controller) => {
              return controller.identifier === this.identifier && controller.__stimulusLazyController;
          })) {
              return;
          }
          import('@fify/media-bundle/controllers/file-with-gallery_controller.js').then((controller) => {
              this.application.register(this.identifier, controller.default);
          });
      }
  },
  'fify--media-bundle--file': class extends Controller {
      constructor(context) {
          super(context);
          this.__stimulusLazyController = true;
      }
      initialize() {
          if (this.application.controllers.find((controller) => {
              return controller.identifier === this.identifier && controller.__stimulusLazyController;
          })) {
              return;
          }
          import('@fify/media-bundle/controllers/file_controller.js').then((controller) => {
              this.application.register(this.identifier, controller.default);
          });
      }
  },
  'fify--media-bundle--gallery': class extends Controller {
      constructor(context) {
          super(context);
          this.__stimulusLazyController = true;
      }
      initialize() {
          if (this.application.controllers.find((controller) => {
              return controller.identifier === this.identifier && controller.__stimulusLazyController;
          })) {
              return;
          }
          import('@fify/media-bundle/controllers/gallery_controller.js').then((controller) => {
              this.application.register(this.identifier, controller.default);
          });
      }
  },
  'fify--media-bundle--lightbox': controller_2,
  'fify--media-bundle--manager': class extends Controller {
      constructor(context) {
          super(context);
          this.__stimulusLazyController = true;
      }
      initialize() {
          if (this.application.controllers.find((controller) => {
              return controller.identifier === this.identifier && controller.__stimulusLazyController;
          })) {
              return;
          }
          import('@fify/media-bundle/controllers/manager_controller.js').then((controller) => {
              this.application.register(this.identifier, controller.default);
          });
      }
  },
  'fify--media-bundle--menu': class extends Controller {
      constructor(context) {
          super(context);
          this.__stimulusLazyController = true;
      }
      initialize() {
          if (this.application.controllers.find((controller) => {
              return controller.identifier === this.identifier && controller.__stimulusLazyController;
          })) {
              return;
          }
          import('@fify/media-bundle/controllers/menu_controller.js').then((controller) => {
              this.application.register(this.identifier, controller.default);
          });
      }
  },
  'fify--media-bundle--swiper': controller_3,
  'fify--security-bundle--altcha': class extends Controller {
      constructor(context) {
          super(context);
          this.__stimulusLazyController = true;
      }
      initialize() {
          if (this.application.controllers.find((controller) => {
              return controller.identifier === this.identifier && controller.__stimulusLazyController;
          })) {
              return;
          }
          import('@fify/security-bundle/controllers/altcha_controller.js').then((controller) => {
              this.application.register(this.identifier, controller.default);
          });
      }
  },
  'fify--websites-bundle--cookie-consent': controller_4,
  'fify--websites-bundle--modal': controller_5,
  'symfony--ux-autocomplete--autocomplete': controller_6,
  'symfony--ux-chartjs--chart': class extends Controller {
      constructor(context) {
          super(context);
          this.__stimulusLazyController = true;
      }
      initialize() {
          if (this.application.controllers.find((controller) => {
              return controller.identifier === this.identifier && controller.__stimulusLazyController;
          })) {
              return;
          }
          import('@symfony/ux-chartjs/dist/controller.js').then((controller) => {
              this.application.register(this.identifier, controller.default);
          });
      }
  },
  'symfony--ux-dropzone--dropzone': controller_7,
  'symfony--ux-lazy-image--lazy-image': controller_8,
  'live': controller_9,
  'symfony--ux-turbo--turbo-core': controller_10,
};